/*
 * @Author: DQL
 * @Date: 2020-03-10 17:15:08
 * @LastEditors: DQL
 * @LastEditTime: 2022-04-06 12:01:34
 * @Description: 业务功能通用配置
 */
export const tableWidthConfig = {
  // 表格一般类型
  common_select: 30, // 复选框
  common_xh: 34, // 序号
  common_sf: 60, // 是否列
  common_rq: 90, // 日期
  common_je: 170, // 金额（20位金额）
  // 业务类型
  tyshxydm: 156, // 统一社会信用代码
  nsrmc: 180, // 纳税人名称
  swjg: 180, // 税务机关
  sl: 60, // 税率
  ssgly: 86 // 税收管理员
};

export const globalConfig = {
  defaultStartYear: 2014 // 年度控件默认起止年份
};
